// extracted by mini-css-extract-plugin
module.exports = {"button":"LanguageSwitcher_button__XJqdQ","languageSwitcherV2Button":"LanguageSwitcher_languageSwitcherV2Button__YzylH"};